module.exports = __webpack_public_path__ + "media/images/check-68f3585962899974bdaedf9016c98198.svg";